exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".monaco-lint-marker-error:before,.monaco-lint-message-error:before{content:\"\\F057\";font:normal normal normal 10px/1 FontAwesome;font-size:inherit;text-rendering:auto;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;color:#f92672;font-size:.9em;cursor:pointer;margin-left:5px}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./src/app/monaco/addons/linter.css
 ** module id = 192
 ** module chunks = 0
 **/